import { Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultImageAttachmentResource,
    ImageAttachmentMutationResourceSchema,
    useImageAttachmentActions,
} from '../../../../../resource/resources/artifacts/attachment/imageAttachmentResource';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ImageAttachmentContent } from './ImageAttachmentContent';

export const ImageAttachmentView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const imageAttachmentActions = useImageAttachmentActions();
    const imageAttachmentQuery = imageAttachmentActions.useGetResource(id);
    const updateImageAttachment = imageAttachmentActions.useUpdateResource();
    const validateImageAttachment = imageAttachmentActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ImageAttachmentMutationResourceSchema,
        defaultValues: defaultImageAttachmentResource,
        submitHandler: async (data) => {
            await updateImageAttachment.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: imageAttachmentQuery.data,
    });

    return (
        <QueryBaseComponent name="ImageAttachment" query={imageAttachmentQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateImageAttachment.data}
                    metaDataInfo={imageAttachmentQuery.data}
                    resourceType={ResourceType.IMAGE_ATTACHMENT}
                >
                    <Text c="dimmed">Image Attachment</Text>
                </ResourceValidationTitleBar>
                <ImageAttachmentContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
